/* NewEden2.0 — Image card carousel (full-width, drag, progress) */
(function () {
  'use strict';

  function initCarousel(root) {
    var viewport = root.querySelector('[data-carousel-viewport]');
    var track = root.querySelector('[data-carousel-track]');
    var bar = root.querySelector('[data-carousel-progress-bar]');
    var progress = root.querySelector('[data-carousel-progress]');
    if (!viewport || !track || !bar || !progress) return;

    function updateProgress() {
      var maxScroll = track.scrollWidth - viewport.clientWidth;
      var ratio = maxScroll > 0 ? viewport.scrollLeft / maxScroll : 0;
      var trackWidth = progress.clientWidth;
      var minWidth = Math.max(48, trackWidth * 0.12);
      var width = maxScroll > 0
        ? Math.max(minWidth, ratio * trackWidth)
        : trackWidth;

      bar.style.width = width + 'px';
      progress.classList.toggle('is-static', maxScroll <= 0);
    }

    var ticking = false;
    viewport.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateProgress();
        ticking = false;
      });
    }, { passive: true });

    progress.addEventListener('click', function (e) {
      var maxScroll = track.scrollWidth - viewport.clientWidth;
      if (maxScroll <= 0) return;

      var rect = progress.getBoundingClientRect();
      var clickRatio = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width));
      viewport.scrollTo({ left: maxScroll * clickRatio, behavior: 'smooth' });
    });

    /* Drag-to-scroll with mouse */
    var isDragging = false;
    var dragMoved = false;
    var startX = 0;
    var scrollStart = 0;

    function onMouseMove(e) {
      if (!isDragging) return;
      var delta = e.pageX - startX;
      if (Math.abs(delta) > 4) {
        if (!dragMoved) {
          dragMoved = true;
          viewport.classList.add('is-dragging');
        }
        e.preventDefault();
        viewport.scrollLeft = scrollStart - delta;
      }
    }

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      viewport.classList.remove('is-dragging');
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', endDrag);
    }

    viewport.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      isDragging = true;
      dragMoved = false;
      startX = e.pageX;
      scrollStart = viewport.scrollLeft;
      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', endDrag);
    });

    viewport.addEventListener('click', function (e) {
      if (!dragMoved) return;
      e.preventDefault();
      e.stopPropagation();
      dragMoved = false;
    }, true);

    viewport.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    window.addEventListener('resize', updateProgress);
    updateProgress();
  }

  function initAll() {
    document.querySelectorAll('[data-image-card-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-image-card-carousel]');
    if (el) initCarousel(el);
  });

  window.addEventListener('load', initAll);
})();
